import forOwn from 'mout/object/forOwn'

/**
 * Determines if any errors exist in verifyErrors
 * @param {object} verifyErrors 
 * @returns {boolean} Do any verifyErrors exist?
 */
export default function hasErrorsQ (verifyErrors) {
  let hasErrors = false
  forOwn(verifyErrors, val => {
    if (val.length > 0) {
      hasErrors = true
    }
  })
  return hasErrors
}


// WEBPACK FOOTER //
// ./src/helpers/assessment/uploadCSV/hasErrorsQ.js